import { Link, Navigate, useNavigate, useParams } from "react-router";

import { FeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { useGetConversation } from "@vega-api/generated/messaging-conversations-v1/messaging-conversations-v1";
import { Tag, TagVariants } from "@vega-core/components/Tag/Tag";
import { m } from "@vega-core/paraglide/messages";
import { isGPCoInvestPortal } from "@vega-core/utils/global";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CoInvestmentFullPaths, CommonPaths } from "@vega-modules/paths";
import { ConversationThread } from "@vega-modules/scenes/CoInvestments/messaging/ConversationThread";

import { CoInvestmentPageHeader } from "../components/CoInvestmentPageHeader/CoInvestmentPageHeader";

export const CoInvestConversationPage = () => {
  useFeatureFlagGuard(
    FeatureFlag.COINVEST_MESSAGING_VD_28584,
    isGPCoInvestPortal ? undefined : CommonPaths.Home,
  );

  const { conversationId = "" } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();

  const conversationQuery = useGetConversation(conversationId, {
    query: { enabled: !!conversationId },
  });

  if (!conversationId) {
    return <Navigate replace to={CoInvestmentFullPaths.CoInvestmentMessages} />;
  }

  const conversation = conversationQuery.data?.data;

  const renderDealTag = () => {
    if (!conversation?.meta.dealId) return null;

    return (
      <Link
        data-testid="coinvest-conversation-deal-link"
        to={CoInvestmentFullPaths.CoInvestmentConfigure.replace(
          ":id",
          conversation.meta.dealId,
        )}
      >
        <Tag variant={TagVariants.Disabled}>{conversation.meta.dealName}</Tag>
      </Link>
    );
  };

  return (
    <div className="mt-1 pb-52">
      <CoInvestmentPageHeader
        backButtonDataTestId="coinvest-conversation-back"
        description={m.coInvestments_messages_subtitle()}
        onBack={() => navigate(CoInvestmentFullPaths.CoInvestmentMessages)}
        showDrawer={false}
        title={m.coInvestments_messages_title()}
      />

      <div className="mt-6 flex items-center gap-3">
        <div className="flex items-center gap-2 min-w-0">
          {conversation?.meta.limitedPartnerName ? (
            <span className="body-base-semibold text-text/primary truncate">
              {conversation.meta.limitedPartnerName}
            </span>
          ) : null}
          {renderDealTag()}
        </div>
      </div>

      <ConversationThread
        conversationId={conversationId}
        testIdPrefix="coinvest"
      />
    </div>
  );
};
